import { useAtom } from '@reatom/npm-react'
import React from 'react'
import styled from 'styled-components'

import { SegmentControl } from '@blade/ui-kit'
import {
  commentsHistoryPeriodAtom,
  commentsHistoryTypeAtom,
} from '@root/features/comment'
import { CommentsHistory } from '@root/features/comment/ui'
import { commentsDrawerDelugeIdAtom } from '@root/features/user/profile-header/atoms'
import { useTranslation } from '@root/shared/localization'
import { Period } from '@root/shared/period'
import { Drawer } from '@root/shared/ui-kit'

import type { Comment } from '@root/entities/comment'

type Props = {}

export const CommentsDrawer: React.FC<Props> = () => {
  const { t } = useTranslation()
  const [openedWithDelugeId, setOpenedWithDelugeId] = useAtom(
    commentsDrawerDelugeIdAtom,
  )

  const [type, setType] = useAtom(commentsHistoryTypeAtom)
  const [period, setPeriod] = useAtom(commentsHistoryPeriodAtom)

  const closeDrawer = () => setOpenedWithDelugeId(undefined)

  return (
    <Root
      title={t('common.comments_other')}
      open={!!openedWithDelugeId}
      onOpenChange={closeDrawer}
    >
      <Content>
        <TabsContainer>
          <SegmentControl size="h30" value={type} onChange={setType}>
            <SegmentControl.Item
              value={'comments' satisfies Comment.CommentType}
            >
              {t('comment.comments')}
            </SegmentControl.Item>
            <SegmentControl.Item
              value={'replies' satisfies Comment.CommentType}
            >
              {t('comment.replies')}
            </SegmentControl.Item>
          </SegmentControl>

          <SegmentControl size="h30" value={period} onChange={setPeriod}>
            {Period.PERIODS.map((period) => (
              <SegmentControl.Item key={period} value={period}>
                {t(Period.PERIOD_LABEL_MAP[period]).toUpperCase()}
              </SegmentControl.Item>
            ))}
          </SegmentControl>
        </TabsContainer>

        {openedWithDelugeId ? (
          <CommentsHistory delugeId={openedWithDelugeId} />
        ) : undefined}
      </Content>
    </Root>
  )
}

const Root = styled(Drawer)`
  height: var(--max-drawer-height);
  background: var(--background-1);
`

const Content = styled.div`
  display: grid;
  grid-template-rows: auto 1fr;
  padding-block: 16px 0;
  height: 100%;
  gap: 16px;
`

const TabsContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 8px;
  padding-inline: 8px;
  flex-wrap: wrap;
  justify-content: space-evenly;
`
